import {
  Kategori,
  Agandeform,
  BostadsvarderingDto,
  BostadsinformationDto,
} from '../types/dtos/VarderingarModel';

const kategoriToAgandeform = (kategori: Kategori): Agandeform =>
  kategori === Kategori.BOSTADSRATT
    ? Agandeform.bostadsrätt
    : Agandeform.äganderätt;

export const varderingToBostadsinformation = (
  vardering: BostadsvarderingDto
): BostadsinformationDto => ({
  id: undefined,
  adress: vardering?.adress?.gata,
  lagenhetsnummer: vardering?.adress?.lagenhetsnummer,
  kommun: '',
  postort: vardering?.adress?.postort,
  postnummer: vardering?.adress?.postnummer,
  boarea: vardering?.parametrar?.boarea,
  antalRum: vardering?.parametrar?.antalRum,
  byggar: vardering?.parametrar?.byggar,
  bostadstyp: undefined,
  sweref99x: vardering?.parametrar?.sweref99x,
  sweref99y: vardering?.parametrar?.sweref99y,
  agandeform: kategoriToAgandeform(vardering?.parametrar?.kategori),
  kallTyp: undefined,
});
